export const OVERVIEW = "overview" as const;
export const SYNC_HISTORY = "sync history" as const;

export const TABS = [OVERVIEW, SYNC_HISTORY];
